import React from "react";
import "./VeDrawer.css";
import { useMediaQuery } from "@mui/material";

export function VeDrawer({
  isOpen,
  onClose,
  side = "right",
  fullWidth = false,
  children,
  topRadius = false,
  style,
  paddingChild,
  backgroundOverlay = true,
}: any) {
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="drawer-overlay"
          style={{ background: backgroundOverlay ? "auto" : "none" }}
          onClick={onClose}
        />
      )}

      {/* Drawer */}
      <div
        className={`drawer drawer-${side} ${isOpen ? "open" : ""} ${
          fullWidth ? "full-width" : ""
        } ${topRadius ? "top-radius" : ""}`}
        style={{
          ...style,
          backgroundColor: "white",
          overflow: "hidden", // Prevents scroll bar
        }}
      >
        <div className={ !isMobile ? "drawer-content" : "drawer-content drawer-content-mobile"}>{children}</div>
      </div>
    </>
  );
}
